import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, QueryParameter, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { OsobaRadnaOprema } from './osoba-radna-oprema';
import { VelicinaStav } from '../../velicina/velicina-stav';
import { List } from 'immutable';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-osoba-radna-oprema-update',
  templateUrl: './osoba-radna-oprema-update.component.html'
})
export class OsobaRadnaOpremaUpdateComponent
extends BaseUpdateComponent<OsobaRadnaOprema> 
implements OnInit {
  // selectedVelicinaSet=-1
  parameterList: List<QueryParameter> = List([]);

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService

  ) { 
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    let VelicinaSetID: QueryParameter = new QueryParameter();
    VelicinaSetID.Name="velicinasetid";
    VelicinaSetID.Value="-1";
    this.parameterList = this.parameterList.push(VelicinaSetID);
    super.ngOnInit();
    if (this.ParentProperty){
      this.baseFormGroup.patchValue({OsobaID: this.ParentProperty.Value});
      this.baseFormGroup.get('OsobaID').disable();
    }
  }

  onItemSelected(selectedItem){
    if (selectedItem!=null){
      this.parameterList = List([])
      let VelicinaSetID: QueryParameter = new QueryParameter();
      VelicinaSetID.Name="velicinasetid";
      VelicinaSetID.Value=selectedItem.VelicinaSetID;
      this.parameterList = this.parameterList.push(VelicinaSetID);
    }
  }

}
